<template lang="pug">
div
  .new-member-container(
    v-if="haveData&&!showLoading&&!showErr&&!isPreRender"
      :style="getContinerstyle()"
      :class="containerClass"
    )
    CommonHeader.header(
      v-if="env.isEasyBikeApp"
      color="#fff",
      title="",
      ref="header",
      :inactiveColor="getHeaderConfig.inactiveColor"
      :backgroundColor="getHeaderConfig.backgroundColor"
      :leftBlackWhenInactive="getHeaderConfig.leftBlackWhenInactive"
      :leftBalckColor="getHeaderConfig.leftBalckColor"
      :left-black-when-inactive="true",
      :leftFlex="0.5"
      :isBackClose="isBackClose"
      inactive-color='black'
      height="0.92rem"
      middleFlex="1 1 auto"
    )
      template(slot='left')
        .top-left-line
      template(slot='middle')
        template(v-if="newH5Version")
          NewTransferTab.categery-tab(
            :tabs="categoryTabs"
            :activeTabKey="activeCategoryKey"
            :type="3"
            @change="handleRideTabChange"
          )
        template(v-else)
          .top-middle-line {{memberMap[tabCode]}}
      template(slot="right")
        .header-menu(
          v-if="getHeaderConfig.showMenu && !newH5Version"
          @click="rule"
          :style="{ backgroundImage: `url(${getHeaderConfig.menuIcon})` }"
        )
        PopMenuButton.prop-button(
          v-if="activeCategoryKey === ANCHOR_MAP.VIP || getHeaderConfig.showElipsisPop"
          icon="more", :menus="menus", @clickItem="clickMenu")
    //- 我的页改版会员
    template(v-if="newH5Version")
      NewTransferTab.category-tab-no-app(
          v-if="!env.isEasyBikeApp"
          :tabs="categoryTabs"
          :activeTabKey="activeCategoryKey"
          :type="3"
          @change="handleRideTabChange"
        )
      .new-ride-card.radius-background(
        v-show="rideCardModuleInfos && rideCardModuleInfos.length && activeCategoryKey === ANCHOR_MAP.RIDE"
      )
        KeepAlive
          rideCardContainer(
            v-if="rideCardModuleInfos && rideCardModuleInfos.length && activeCategoryKey === ANCHOR_MAP.RIDE"
            :moduleInfos="rideCardModuleInfos"
            :propVersion="propVersion"
            :isApp="env.isEasyBikeApp"
            @refresh="getData"
            @tabChange="handleRideCardContainerTabChange"
          )
      .new-member(
        v-show="vipPageList && vipPageList.length && activeCategoryKey === ANCHOR_MAP.VIP"
        :style="nemMembeStyle")
        KeepAlive
          vipContainer(
            v-if="vipPageList && vipPageList.length && activeCategoryKey === ANCHOR_MAP.VIP"
            :vipPageList="vipPageList"
            :tabCode="tabCode"
            :isApp="env.isEasyBikeApp"
            @refresh="getData"
            @closeOpen="closeOpen"
            @tabChange="handleVipContainerTabChange"
          )
    //- 新版会员
    template(v-else)
          //- 新版会员tab。单车/助力车卡 和 单车超级会员
          TransferTab(
            v-if="tabList && tabList.length > 1"
            :show="tabCode!=='ladder'&&!!activeAnchor"
            :activeTabKey="activeAnchor"
            :isApp="env.isEasyBikeApp"
            :tabs="tabList"
            @change="handleTabChange"
            :tabCode="tabCode"
          )
          .new-ride-card(v-if="activeAnchor === ANCHOR_MAP.RIDE")
            rideCardPage(
              v-if="rideCardDatas && !isCardLoading"
              :rideCardData="rideCardDatas"
              :propVersion="propVersion"
            )
            //- 骨架屏
            CardLoadingModule(v-if="isCardLoading")
          .new-member(v-else  :style="nemMembeStyle")
            unopen(
              v-if="!isOpen && activeUnOpenVipData && Object.keys(activeUnOpenVipData).length"
              :vipData="activeUnOpenVipData"
              @refresh="getData"
              @closeOpen="closeOpen"
              :key="activeUnOpenVipData.goodCategory||''")
            opened(
              v-if="isOpen"
              :openedData="openedData"
              :downPropVersion="downPropVersion"
              @refresh="getOpenedVipData"
              @closeOpen="closeOpen")
    CompletedModal(
      ref="complete",
      @confirm="getLinkData",
      :amount="save",
      :commonBonus="commonBonus",
      @close="getLinkData"
    )
  errorPage(v-if="showErr && !isPreRender" @refresh="getData")
  loadingPage(v-if="showLoading || isPreRender")
</template>
<script>
import { getTokenAndLocation, isPreRender, safeGet } from '@/utils';
import { redirectToCardComplete } from '@/utils/vip';
import config from '@/const/config';
import {
  unOpenedMultiVersion,
  openedMultiVersion,
  getSuperUserPropert,
  getUnOpenSuperVip,
  getOpenedSuperVip,
} from '@/api/vip';
import { Native, env } from '@hb/hbridge';
import { Navigator } from '@hb/h5-navigator';
import { PropVersionMap } from '@/const/vip';
import { getTWCards } from '@/api/card';
import { getVersion, getSystemCode } from '@/utils/systemCode';
import { getImageUrl } from '@/utils/image';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import deepCopy from '@/utils/deepCopy';
import PopMenuButton from '@/components/pop-menu-button';
import CommonHeader from '@/components/common-middle-header';
import eventBus from '@/const/eventBus.js';
import {
  LotteryNewAppBgm, FreeRightsVersionBg, HeaderMenuDefaultImg, HeaderMenuFreeRightsImg,
} from '@/assets/imgAssets';
import { BLACK_LEFT_ICON, WHITE_LEFT_ICON } from '@/const';
import RideCardContainer from './components/ride-card-container.vue';
import opened from './components/new-member/opened.vue';
import unopen from './components/new-member/unopen.vue';
import CompletedModal from './components/completed-modal.vue';
import NewTransferTab from './components/new-transfer-tab.vue';
import { getSource, getTWCardPlatform, tryCatch } from '../../../utils';
import { ParamsUtil } from '../../../utils/params';
import loadingPage from './components/new-member/loading-page';
import {
  ANCHOR_MAP,
  GoodCategoryMap,
  BACKGROUND_IMAGES,
  PADDING_TOP,
  MENUS,
  TABLOGO_IMG,
} from '../consts';
import VipContainer from './components/vip-container.vue';
import TransferTab from './components/transfer-tab.vue';
import rideCardPage from './components/new-member/ride-card-page.vue';
import CardLoadingModule from './components/new-member/card-loading-module.vue';

export default {
  components: {
    CommonHeader,
    unopen,
    opened,
    PopMenuButton,
    RideCardContainer,
    CompletedModal,
    loadingPage,
    errorPage: () => import('./components/new-member/error-page.vue'),
    NewTransferTab,
    VipContainer,
    TransferTab,
    rideCardPage,
    CardLoadingModule,
  },
  data() {
    return {
      env,
      isBackClose: true,
      isOpen: false,
      propVersion: 'bike', // TO 这里应该没有
      activeAnchor: '',
      vipData: {},
      tabCode: 'bike',
      rideCardDatas: null,
      rideCardModuleInfos: [], // rideCardItem 的所有 moduleInfos
      ANCHOR_MAP,
      BACKGROUND_IMAGES,
      PADDING_TOP,
      save: '',
      commonBonus: null,
      showAppPrivilege: false,
      adsource: null,
      haveData: false,
      redirectUrl: '',
      timer: null,
      showErr: false,
      showLoading: false,
      openedData: {}, // 已开卡数据
      // 添加 freeRightsVersion 数据属性
      freeRightsVersion: false, // TO 这里应该没有
      tabList: [],
      unOpenVipDataList: [],
      rideOneCentVersion: '',
      // 保存原始的 multiGoods 数据
      multiGoodsData: [],
      categoryTabs: [],
      activeCategoryKey: '',
      // 保存提取的骑行卡子 tab 信息
      rideCardSubTabs: [],
      vipPageList: [],
      newH5Version: true,
      rideCardData: null,
      memberMap: {
        bike: '单车会员',
        ebike: '助力车会员',
        ladder: '畅享出行会员',
      },
      // 是否是预渲染
      isPreRender: isPreRender(),
      isCardLoading: true,
      isFirstUseTabcode: true,
      downPropVersion: false,
    };
  },
  computed: {
    getHeaderConfig() {
      const isVipAnchor = [
        ANCHOR_MAP.ONECENTVIP, ANCHOR_MAP.VIP].includes(this.activeAnchor);
      const leftBlackWhenInactive = isVipAnchor;
      if (this.newH5Version) {
        let backgroundColor = '254, 208, 123'; // 默认颜色
        let leftBalckColor = WHITE_LEFT_ICON;
        if (this.activeCategoryKey === ANCHOR_MAP.RIDE) {
          backgroundColor = '0, 119, 223';
          leftBalckColor = WHITE_LEFT_ICON;
        } else if (this.activeCategoryKey === ANCHOR_MAP.VIP) {
          leftBalckColor = BLACK_LEFT_ICON;
          if (this.freeRightsVersion) {
            backgroundColor = '8,17,71';
            leftBalckColor = WHITE_LEFT_ICON;
          }
        }
        return {
          leftBalckColor,
          backgroundColor,
        };
      }
      // 如果是freeRightsVersion，使用特定颜色
      if (this.freeRightsVersion) {
        return {
          inactiveColor: this.activeAnchor === ANCHOR_MAP.VIP ? '#FFE1D3' : '#fff',
          leftBlackWhenInactive: false, // 黑色箭头
          showMenu: true, // 显示自定义规则|协议
          showElipsisPop: false, // ...弹出 规则协议
          menuIcon: HeaderMenuFreeRightsImg, // 规则|协议 图片
        };
      }
      return {
        showMenu: this.activeAnchor !== ANCHOR_MAP.RIDE && !this.isOpen,
        showElipsisPop: this.activeAnchor !== ANCHOR_MAP.RIDE && this.isOpen,
        inactiveColor: isVipAnchor ? 'black' : 'white',
        leftBlackWhenInactive,
        menuIcon: HeaderMenuDefaultImg,
      };
    },
    // 根据 isOpen 过滤菜单，如果 isOpen 为 false，则移除"购买记录"
    menus() {
      if (this.isOpen) {
        return MENUS;
      }
      return MENUS.filter((menu) => menu.name !== '购买记录');
    },
    // 移除 freeRightsVersion 计算属性
    leftTab() {
      return {
        bike: {
          title: '单车卡',
          topWord: '单车超级会员',
          subWord: '30天不限次卡+超值权益',
          rightChoose: '单车超级会员',
          logoImg: !this.freeRightsVersion
            ? 'https://m.hellobike.com/resource/gallery/61/h13kA1cY_Group%2057.png?x-oss-process=image/quality,q_80'
            : 'https://m.hellobike.com/helloyun3/22042/ktn80woc_8198923.png',
        },
        ebike: {
          title: '助力车卡',
          topWord: '助力车超级会员',
          subWord: '30天6次卡+超值权益',
          rightChoose: '助力车超级会员',
          logoImg: 'https://m.hellobike.com/resource/gallery/61/4bjqt8NA_Group%2057%20(1).png?x-oss-process=image/quality,q_80',
        },
      };
    },
    nemMembeStyle() {
      if (this.freeRightsVersion) { return { paddingTop: '0' }; }

      // 兼容小程序超级会员头部样式
      if (this.vipData && this.vipData.goodsList) {
        const info = this.vipData.goodsList
          .find((item) => item.propVersion === 'ladder') || {};
        return {
          paddingTop: (info.showSpecialExpiredAb && !env.isEasyBikeApp)
            ? '0' : '0.4rem',
        };
      }
      return {};
    },
    lotteryNewVersion() {
      let showLottery = false;
      const { propVersion } = this.openedData;
      if (propVersion) {
        showLottery = [
          PropVersionMap.RIDE,
          PropVersionMap.RIDE_TRIAL,
          PropVersionMap.RIDE_BIKE,
          PropVersionMap.RIDE_UNIVERSAL].includes(propVersion);
      }
      return showLottery;
    },
    containerClass() {
      const classes = [];
      if (this.newH5Version) {
        if (this.vipLength === 1) {
          // 1个会员时有特殊样式
          classes.push('single-vip');
        }
        classes.push('new-h5-version');

        if (this.freeRightsVersion) {
          classes.push('free-rights-version');
          return classes;
        }
        return classes;
      }
      if ((!env.isEasyBikeApp && this.activeAnchor !== ANCHOR_MAP.RIDE)
        || this.freeRightsVersion) {
        classes.push('no-padding-container');
      }
      if (this.freeRightsVersion && this.activeAnchor === ANCHOR_MAP.VIP) {
        classes.push('free-rights-version');
      }
      return classes;
    },
    // 计算最终的 tabCode，确保响应式更新
    computedTabCode() {
      return this.getTabCode();
    },
  },
  watch: {
    rideCardData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.rideCardDatas = val;
      },
    },
    // 添加 propVersion 的监听器
    propVersion: {
      immediate: true,
      handler(newVal) {
        this.freeRightsVersion = ['ride_steady_version', 'ride_radical_version'].includes(newVal) || false;
        this.getDynamicTabs();
      },
    },
  },
  provide() {
    return {
      getSignPayChannels: () => this.signPayChannels || [],
      freeRightsVersion: () => this.freeRightsVersion || false, // 提供给子组件
      propVersion: () => this.propVersion || '', // 版本信息
      rideOneCentVersion: () => (this.activeAnchor === 'rideCard' || this.activeCategoryKey === 'rideCard') && this.rideOneCentVersion, // 一分骑版本信息
      newH5Version: () => this.newH5Version || false,
      latestTabCode: () => this.computedTabCode,
    };
  },
  created() {
    // 解决刷新页面后，页面由于渲染问题，导致的白屏问题
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    this.showLoading = true;

    // 预渲染
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }

    this.getData();
  },
  mounted() {
    // 预渲染
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }

    eventBus.$on('refreshNewMember', this.handleRefreshNewMember);
    eventBus.$on('buyMember', this.handleBuyMember);
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    eventBus.$off('refreshNewMember', this.handleRefreshNewMember);
    eventBus.$off('buyMember', this.handleBuyMember);
  },
  methods: {
    handleRefreshNewMember() {
      this.timer = setTimeout(() => {
        this.getData('rideCard');
      }, 1000);
    },
    handleBuyMember(arg1, arg2) {
      this.commonBonus = arg1;
      this.save = arg2;
      this.$refs.complete.open();
    },
    /**
     * 处理 Promise 结果
     */
    async getPreFetchResult(adsource) {
      const preFetchName = 'getVipPromise';
      const preFetchPromise = window[preFetchName];

      if (preFetchPromise) {
        try {
          const { success, result } = await preFetchPromise || {};
          const { data = {} } = result || {};

          if (success && Array.isArray(data.multiGoods)) {
            this.trackPageExposure();
            this.handlePageData(data.multiGoods);
            this.updateState({
              haveData: true,
              showErr: false,
              showLoading: false,
            });
          } else {
            throw new Error();
          }
          delete window[preFetchName];
        } catch (error) {
          this.updateState({
            haveData: false,
            showErr: true,
            showLoading: false,
          });
          const code = safeGet(error, 'code', null);
          if (this.isOpen && code === 50005) {
            this.getLinkData();
          } else {
            this.processNewMemberData(adsource);
          }
          delete window[preFetchName];
        }
      } else {
        this.processNewMemberData(adsource);
      }
    },
    /**
     * 更新组件状态
     */
    updateState(status) {
      this.haveData = status.haveData;
      this.showErr = status.showErr;
      this.showLoading = status.showLoading;
    },
    getImageUrl,
    /**
     * 获取 tabCode
     * 新版H5：取点击菜单的tabCode（newH5TabCode）
     * 老版H5：取URL参数中的tabCode
     * @returns {string} 返回最终的tabCode
     */
    getTabCode() {
      const newH5TabCode = (this.newH5Version && this.tabCode) || '';
      const newH5Version = this.newH5Version || false;
      const defaultTabCode = 'bike';

      // 判断是否是新版H5
      if (newH5Version) {
        // 新版H5：取点击菜单的tabCode

        return newH5TabCode || defaultTabCode;
      }
      const { tabCode: queryTabCode } = ParamsUtil.getParams();
      // 老版H5：取query中的tabCode
      return queryTabCode || defaultTabCode;
    },
    handleRideTabChange({ tabKey }) {
      this.activeCategoryKey = tabKey;
    },
    getPropVersionAndActiveUnOpenVipData() {
      if (this.isOpen) return;
      const activeUnOpenVipData = this.unOpenVipDataList
        .find((item) => item.goodCategory === this.activeAnchor) || undefined;
      if (activeUnOpenVipData) {
        this.propVersion = safeGet(activeUnOpenVipData, 'goodsList.0.propVersion', '');
        this.activeUnOpenVipData = activeUnOpenVipData;
      } else {
        // 未找到：没有数据 或 是单车tab
        this.propVersion = safeGet(this.unOpenVipDataList, '0.goodsList.0.propVersion', '');
      }
    },
    getTrastabClass(activeAnchor) {
      if (activeAnchor === ANCHOR_MAP.RIDE && env.isEasyBikeApp) {
        return 'ridetab';
      }
      if (activeAnchor === ANCHOR_MAP.RIDE && !env.isEasyBikeApp) {
        return 'ridetab-ali';
      }
      return '';
    },
    rightStyle() {
      if (this.tabCode === 'ebike' && this.activeAnchor !== this.ANCHOR_MAP.VIP) {
        return 'tab-right-ebike';
      }
      return '';
    },
    closeOpen(flag) {
      this.isBackClose = flag;
    },
    getHeaderMenuBg() {
      return this.freeRightsVersion ? HeaderMenuFreeRightsImg : HeaderMenuDefaultImg;
    },
    handleBack() {
      Native.closeWebView();
    },
    async extractMultiGoods(multiGoods) {
      // 保存原始数据
      this.multiGoodsData = multiGoods;
      // 获取动态tabs
      this.getDynamicTabs();
      // 以下是未开卡页处理
      const vipItems = multiGoods.filter((item) => (item && item.goodCategory) && /vip/i.test(item.goodCategory));
      if (vipItems.length > 0 && !this.isOpen) {
        this.unOpenVipDataList = vipItems;
        this.getPropVersionAndActiveUnOpenVipData();
      }
      // 获取到骑行卡 各个模块moduleInfos列表，请求数据
      const rideCardItems = multiGoods.filter((i) => i && i.goodCategory === GoodCategoryMap.RIDE);
      if (rideCardItems.length > 0) {
        this.rideOneCentVersion = rideCardItems[0].propVersion ? rideCardItems[0].propVersion : '';
        let temp = deepCopy(rideCardItems[0]);
        temp = await this.assignTryingCardData(temp.moduleInfos);
        this.rideCardData = temp;
        this.isCardLoading = false;
      }
    },
    async assignTryingCardData(moduleInfos) {
      const vipRecommendModules = moduleInfos.filter((info) => info.moduleCode === 'page_vip_recommend_module');
      const promises = [];

      if (vipRecommendModules.length > 0) {
        moduleInfos.forEach((info, index) => {
          if (info.moduleCode === 'page_vip_recommend_module' && moduleInfos[index + 1] && moduleInfos[index + 1].moduleData && moduleInfos[index + 1].moduleCode === 'page_main_tying_card_module') {
            const code = moduleInfos[index + 1].moduleData.channelCode;
            promises.push(this.getValue(
              moduleInfos[index + 1].moduleData.channelCode,
            ).then((data) => {
              // eslint-disable-next-line no-param-reassign
              info.moduleData.tryingCardData = data;
              // eslint-disable-next-line no-param-reassign
              info.moduleData.tryingCardData.channelCode = code;
            }));
          }
        });
      } else {
        const tyingModules = moduleInfos.filter((info) => info.moduleCode === 'page_main_tying_card_module');
        if (tyingModules.length > 0) {
          moduleInfos.forEach((info) => {
            if (info.moduleCode === 'page_sub_tying_card_module') {
              const tempcode = info.moduleData.channelCode;
              promises.push(this.getValue(info.moduleData.channelCode).then((data) => {
                // eslint-disable-next-line no-param-reassign
                info.moduleData = data;
                // eslint-disable-next-line no-param-reassign
                info.moduleData.changeChoose = tempcode;
                const code = tyingModules[0].moduleData.channelCode;
                return this.getValue(
                  tyingModules[0].moduleData.channelCode,
                ).then((tryingCardData) => {
                  // eslint-disable-next-line no-param-reassign
                  info.moduleData.tryingCardData = tryingCardData;
                  // eslint-disable-next-line no-param-reassign
                  info.moduleData.tryingCardData.channelCode = code;
                });
              }));
            }
          });
        }
      }

      moduleInfos.forEach((x) => {
        if (x.moduleCode === 'page_my_card_module') {
          const infos = moduleInfos.find((info) => info.moduleCode === 'page_vip_recommend_coupon_visualization_module');
          if (infos) {
            // eslint-disable-next-line no-param-reassign
            x.moduleData.propertyDetailDTOS = infos.moduleData.propertyDetailDTOS;
            // eslint-disable-next-line no-param-reassign
            x.moduleData.commonBonus = infos.moduleData.commonBonus;
          }
        }
        if (x.moduleCode === 'page_sub_tying_card_module') {
          const code = x.moduleData.channelCode;
          promises.push(this.getValue(x.moduleData.channelCode).then((data) => {
            // eslint-disable-next-line no-param-reassign
            x.moduleData = data;
            // eslint-disable-next-line no-param-reassign
            x.moduleData.channelCode = code;
          }));
        }
        if (x.moduleCode === 'page_main_tying_card_coupon_visualization_module') {
          const code = x.moduleData.channelCode;
          promises.push(this.getValue(x.moduleData.channelCode).then((data) => {
            // eslint-disable-next-line no-param-reassign
            x.moduleData = data;
            // eslint-disable-next-line no-param-reassign
            x.moduleData.rideMoneyData = this.getRideMoney(x.moduleData.packages);
            // eslint-disable-next-line no-param-reassign
            x.moduleData.channelCode = code;
          }));
        }
      });
      await Promise.all(promises);
      return moduleInfos;
    },
    async getValue(val) {
      const {
        tabCode,
        adSource,
      } = ParamsUtil.getParams();
      this.tabCode = tabCode || 'bike';
      const { token, cityCode, adCode } = await getTokenAndLocation();
      const res = await getTWCards({
        token,
        adCode,
        cityCode,
        businessId: tabCode === 'bike' ? 0 : 1, // 单车
        channelCodes: [val],
        platform: getTWCardPlatform(),
        version: await getVersion(),
        systemCode: getSystemCode(),
        adSource,
      }).then((v) => tryCatch(() => v.data.packageGroups[0]), null)
        .catch(() => ({}));
      return res;
    },
    getRideMoney(rideData) {
      // 获取
      let temppackages = '';
      if (rideData && rideData.length > 0) {
        // 这里怎么是ride 哪来的 是bike？
        if (this.tabCode === 'ride') {
          const temp = rideData.find((item) => item.paymentLimit === 1);
          if (temp) {
            temppackages = temp;
          }
        } else {
          const temp = rideData.find((item) => item.paymentLimit === 0);
          if (temp) {
            temppackages = temp;
          }
        }
        return (temppackages.actualPrice && temppackages.actualPrice.finalPrice) || '';
      }
      return '';
    },
    clickMenu(index) {
      const menuItem = this.menus[index];
      if (!menuItem) return;

      if (menuItem.name === '规则协议') {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_newrules2',
          categoryId: 'platform',
          businessInfo: {
            adsource: getSource(),
          },
        });
        Navigator.go('https://m.hellobike.com/mf/spa/u_jsawic/latest/MA2112242694445671692369920.html?activityCode=MA2112242694445671692369920', { isRuleLink: true });
      } else if (menuItem.name === '购买记录') {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_buycardrecord',
          categoryId: 'platform',
          businessInfo: {
            adsource: getSource(),
          },
        });
        this.$router.push('/vip/history');
      } else if (menuItem.name === '客服中心') {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_user_service',
          categoryId: 'platform',
          businessInfo: {},
        });
        Navigator.go(`https://m.hellobike.com/AppHelloBikeReactH5/${config.envUrlMixin}latest/pr_index_entrance.html#/entrance?sourcePage=MEMBER_HOME_PAGE`);
      }
    },
    getContinerstyle() {
      let imageUrl = BACKGROUND_IMAGES.DEFAULT;
      let paddingTop = '';

      // 先确定使用哪个图片URL
      if (this.newH5Version) {
        if (this.activeCategoryKey === ANCHOR_MAP.RIDE) {
          imageUrl = BACKGROUND_IMAGES.NEW_H5_RIDE;
        } else if (this.freeRightsVersion) {
          imageUrl = BACKGROUND_IMAGES.NEW_H5_FREE_RIGHTS;
        } else {
          imageUrl = BACKGROUND_IMAGES.NEW_H5_VIP;
        }
      } else if (this.freeRightsVersion) {
        if (this.activeAnchor === ANCHOR_MAP.RIDE) {
          imageUrl = BACKGROUND_IMAGES.RIDE_FREE_RIGHTS;
        } else {
          imageUrl = FreeRightsVersionBg;
        }
      } else if (this.activeAnchor === this.ANCHOR_MAP.RIDE && this.tabCode === 'ebike') {
        imageUrl = BACKGROUND_IMAGES.RIDE_EBIKE;
      } else if (this.activeAnchor === this.ANCHOR_MAP.RIDE && this.tabCode === 'bike') {
        imageUrl = BACKGROUND_IMAGES.RIDE_BIKE;
      } else if (this.tabCode === 'ladder') {
        imageUrl = BACKGROUND_IMAGES.LADDER;
      } else if (this.lotteryNewVersion) {
        imageUrl = LotteryNewAppBgm;
      }
      // 最后统一处理一次
      const backgroundImage = `url(${getImageUrl(imageUrl)})`;

      // paddingTop
      if (env.isEasyBikeApp && this.newH5Version) {
        paddingTop = PADDING_TOP.EASY_BIKE_APP;
      } else if (!env.isEasyBikeApp && this.newH5Version) {
        paddingTop = PADDING_TOP.NOT_EASY_BIKE_APP;
      }

      return {
        backgroundImage,
        paddingTop,
      };
    },
    rule() {
      window.onpageshow = null;
      window.addEventListener('pageshow', () => {
        window.location.reload();
      });
      Navigator.go(
        'https://m.hellobike.com/mf/spa/u_jsawic/latest/MA2112242694445671692369920.html?activityCode=MA2112242694445671692369920',
        { isRuleLink: true },
      );
    },
    changeChoose(val) {
      if (val) {
        this.activeAnchor = ANCHOR_MAP.VIP;
      } else {
        // TO tab埋点
        if (this.tabCode === 'bike') {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_bike_tab',
            categoryId: 'platform',
            businessInfo: {},
          });
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_bike_tab',
            contentId: 'platform_bike_tab',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        if (this.tabCode === 'ebike') {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_ebike_tab',
            categoryId: 'platform',
            businessInfo: {},
          });
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_ebike_tab',
            contentId: 'platform_ebike_tab',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        this.activeAnchor = ANCHOR_MAP.RIDE;
      }
      this.getContinerstyle();
    },
    async getLinkData() {
      await redirectToCardComplete();
    },
    async processNewMemberData(adsource) {
      let api = '';
      api = this.isOpen ? getOpenedSuperVip : getUnOpenSuperVip;
      const { token, adCode, cityCode } = await getTokenAndLocation();
      try {
        const { newTabCode, newSubTabCode, adsource: queryAdsource } = ParamsUtil.getParams();
        const adsourceParam = adsource || queryAdsource;
        // 确认是否空值会传
        const params = {
          token,
          tabCode: this.tabCode,
          cityCode,
          adCode,
          ...(adsourceParam && this.isFirstUseTabcode && { adsource: adsourceParam }),
          ...(newTabCode && this.isFirstUseTabcode && { newTabCode }),
          ...(newSubTabCode && this.isFirstUseTabcode && { newSubTabCode }),
        };
        // 只在首次请求时传递，避免重复传递
        this.isFirstUseTabcode = false;
        // 只在已开卡接口需要这两个参数
        if (this.isOpen) {
          params.goodsType = '1';
          params.pageCode = 'newOpen';
        }
        if (this.isOpen && adsource === 'rideCard') {
          params.newTabCode = 'rideCard';
          params.newSubTabCode = this.tabCode;
        }
        const res = await api(params);
        // 调用埋点函数
        // 重置一分骑版本信息
        // this.rideOneCentVersion = '';
        if (res.data && Array.isArray(res.data.multiGoods)) {
          this.handlePageData(res.data.multiGoods);
          this.$nextTick(() => {
            this.trackPageExposure();
          });
          // this.extractMultiGoods(res.data.multiGoods);
        } else {
          throw new Error();
        }
        this.updateState({
          haveData: true,
          showErr: false,
          showLoading: false,
        });
      } catch (error) {
        this.updateState({
          haveData: false,
          showErr: true,
          showLoading: false,
        });
        const code = safeGet(window, '__error.code', null);
        if (this.isOpen && code === 50005) {
          this.getLinkData();
        }
      }
    },
    async getData(adsource = '') {
      const { isOpen, tabCode, newH5Version } = ParamsUtil.getParams();
      this.isOpen = isOpen === 'true';
      this.tabCode = tabCode || 'bike';
      this.newH5Version = newH5Version === 'true';

      if (this.newH5Version) {
        this.getPreFetchResult(adsource);
      } else {
        // eslint-disable-next-line no-unused-expressions
        this.isOpen === false
          ? this.getUnOpenedMultiVersion(adsource)
          : this.getOpenedMultiVersion(adsource);
      }
    },
    /** 获取开卡数据 */
    async getOpenedMultiVersion(adsource) {
      await Promise.all([
        this.handleMultiVersion(openedMultiVersion, true, adsource),
        this.getOpenedVipData(),
      ]);
      this.showLoading = false;
    },
    /** 获取未开卡数据 */
    async getUnOpenedMultiVersion(adsource) {
      await this.handleMultiVersion(unOpenedMultiVersion, false, adsource);
      this.showLoading = false;
    },

    async getOpenedVipData() {
      // 获取已开数据
      const { token, cityCode, adCode } = await getTokenAndLocation();
      try {
        const res = await getSuperUserPropert({
          token,
          cityCode,
          adCode,
          systemCode: getSystemCode(),
          goodsType: '1',
          pageCode: 'newOpen',
        });
        if (res && res.data) {
          this.openedData = res.data;
          this.propVersion = res.data.propVersion || '';
          this.downPropVersion = !!res.data.downPropVersion;
          this.showLoading = false;
        }
        // eslint-disable-next-line no-empty
      } catch (e) {

      }
    },
    /**
     * 页面曝光埋点
     * 根据activeAnchor和tabCode状态进行相应的埋点上报
     */
    trackPageExposure() {
      const topActiveAnchor = this.newH5Version ? this.activeCategoryKey : this.activeAnchor;
      if (topActiveAnchor === 'rideCard') {
        if (this.tabCode === 'bike') {
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_bike_tab',
            contentId: 'platform_bike_tab',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        if (this.tabCode === 'ebike') {
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_ebike_tab',
            contentId: 'platform_ebike_tab',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      } else if (this.isOpen) {
        // 开卡
        UBT.pageView({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          businessInfo: {
            adsource: getSource(),
          },
        });
      } else {
        // 未开卡
        UBT.pageView({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          businessInfo: {
            adsource: getSource(),
          },
        });
      }
    },
    handlePageData(multiGoods) {
      // 保存原始数据
      this.multiGoodsData = multiGoods;
      // 1. 提取顶层 tab（商品级别）- 用于 categoryTabs
      this.extractTopLevelTabs(multiGoods);


      // 2. 处理其他业务逻辑（与原 extractMultiGoods 类似）
      this.processMultiGoodsData(multiGoods);
    },
    /**
     * 提取顶层 tab（商品级别）
     * 从 multiGoods 中每个商品直接提取 tabName 和 tabCode
     */
    extractTopLevelTabs(multiGoods) {
      if (!Array.isArray(multiGoods) || multiGoods.length === 0) {
        return;
      }

      const topLevelTabs = [];
      multiGoods.forEach((item) => {
        if (item && (item.tabName || item.tabCode)) {
          const tabInfo = {
            title: item.tabName || '',
            tabKey: item.tabCode || '',
            subTitle: item.subTitle || '',
            anchor: item.anchor || false,
          };
          // 如果是 vip tab，保留原来的logoImg
          if (item.tabCode === 'vip') {
            tabInfo.logoImg = TABLOGO_IMG;
          }
          topLevelTabs.push(tabInfo);
        }
      });


      if (topLevelTabs.length > 0) {
        // 更新 categoryTabs
        this.categoryTabs = topLevelTabs;
        // 先查找 anchor 为 true 的 tab（被选中的）
        const anchorItem = multiGoods.find(
          (item) => item.anchor === true && (item.tabName || item.tabCode),
        );
          // 如果有被选中的，使用它的 tabCode；否则使用第一个
        this.activeCategoryKey = anchorItem
          ? (anchorItem.tabCode || '')
          : topLevelTabs[0].tabKey;
      }
    },
    /**
     * 处理 multiGoods 数据的其他业务逻辑
     */
    processMultiGoodsData(multiGoods) {
      // 处理未开卡页的会员数据
      const vipItem = multiGoods.find((item) => item && item.tabCode === 'vip');
      this.vipPageList = safeGet(vipItem, 'moduleInfos', []);
      this.vipLength = this.vipPageList.length;
      // 提取骑行卡模块数据
      this.extractRideCardModuleInfos(multiGoods);

      if (this.rideCardModuleInfos.length > 0) {
        const rideCardItems = multiGoods.find(
          (i) => i && i.tabCode === GoodCategoryMap.RIDE,
        ) || {};
        if (rideCardItems && Object.keys(rideCardItems).length > 0) {
          const rideCardInfo = rideCardItems.moduleInfos.find((item) => item.moduleCode === 'ride_card_module') || {};
          const { moduleInfos = [] } = rideCardInfo.moduleData || {};
          const bikeCardModule = moduleInfos.find((card) => card.tabCode === 'bike');
          this.rideOneCentVersion = safeGet(bikeCardModule, 'moduleData.propVersion', '');
        }
      }
    },
    async handleMultiVersion(apiFunction, isOpen, adsource = '') {
      // 优先使用传入的adsource，否则使用query中的adsource
      const {
        token, adCode, cityCode,
      } = await getTokenAndLocation();
      const {
        adsource: queryAdsource,
      } = ParamsUtil.getParams(window.location.href);
      try {
        const res = await apiFunction({
          token,
          tabCode: this.tabCode,
          systemCode: getSystemCode(),
          cityCode,
          adCode,
          version: await getVersion(),
          adsource: adsource || queryAdsource,
        });
        this.activeAnchor = res.data.defaultAnchor;
        // 调用埋点函数
        this.trackPageExposure();
        // 重置一分骑版本信息
        this.rideOneCentVersion = '';
        if (res.data && Array.isArray(res.data.multiGoods)) {
          this.extractMultiGoods(res.data.multiGoods);
        }
        this.haveData = true;
        this.showErr = false;
      } catch (error) {
        this.haveData = false;
        this.showLoading = false;
        this.showErr = true;
        const code = safeGet(window, '__error.code', null);
        if (isOpen && code === 50005) {
          this.getLinkData();
        }
      }
    },
    getTabsConfig() {
      return [
        {
          title: this.leftTab[this.tabCode].title,
        },
        {
          title: this.leftTab[this.tabCode].topWord,
          subtitle: this.leftTab[this.tabCode].subWord,
          logo: this.leftTab[this.tabCode].logoImg,
          showBadge: !this.isOpen,
          badgeText: '更省',
        },
      ];
    },
    getDynamicTabs() {
      if (this.tabCode === 'ladder') return;
      const goodsTab = this.multiGoodsData.map((item) => item.goodCategory) || [];
      if (goodsTab && goodsTab.length) {
        this.tabList = goodsTab.map((item) => this.tabMap()[this.tabCode][item]);
      }
    },
    handleVipContainerTabChange({ tabKey }) {
      // vip-container传过来的tabKey即会员版本
      this.propVersion = tabKey;
    },
    handleRideCardContainerTabChange({ tabKey }) {
      // 处理 rideCardContainer 内部的 tab 切换
      // 可以根据需要进行额外的处理，比如埋点等
      this.tabCode = tabKey;
    },
    /**
     * 从 multiGoods 中提取 rideCardItem 的所有 moduleInfos
     */
    extractRideCardModuleInfos(multiGoods) {
      // 骑行卡所有数据处理
      if (!Array.isArray(multiGoods) || multiGoods.length === 0) {
        this.rideCardModuleInfos = [];
        return;
      }

      // 查找骑行TAB下数据
      const rideCardItem = multiGoods.find(
        (item) => item && item.tabCode === ANCHOR_MAP.RIDE,
      );

      // 使用 safeGet 安全获取 moduleInfos，并检查是否为数组
      const moduleInfos = safeGet(rideCardItem, 'moduleInfos');
      this.rideCardModuleInfos = Array.isArray(moduleInfos) ? moduleInfos : [];
    },
    handleTabChange({ tabKey }) {
      this.activeAnchor = tabKey;
      if (tabKey === 'rideCard') {
        // UBT埋点
        if (this.tabCode === 'bike') {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_bike_tab',
            categoryId: 'platform',
            businessInfo: {},
          });
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_bike_tab',
            contentId: 'platform_bike_tab',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        if (this.tabCode === 'ebike') {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_ebike_tab',
            categoryId: 'platform',
            businessInfo: {},
          });
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_ebike_tab',
            contentId: 'platform_ebike_tab',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      }

      this.getContinerstyle();
      this.getPropVersionAndActiveUnOpenVipData();
    },
    tabMap() {
      return {
        bike: {
          rideCard: {
            tabKey: 'rideCard',
            title: '单车卡',
          },
          vip: {
            tabKey: 'vip',
            title: this.isOpen && this.propVersion === PropVersionMap.RIDE_ONE_CENT ? '1分骑会员' : '单车超级会员',
            subTitle: this.isOpen && this.propVersion === PropVersionMap.RIDE_ONE_CENT ? '骑行单单0.01元' : '单车30天不限次',
            logoImg: this.freeRightsVersion ? 'https://m.hellobike.com/helloyun3/22042/ktn80woc_8198923.png' : 'https://m.hellobike.com/09b24a472f.png',
          },
          oneCentVip: {
            tabKey: 'oneCentVip',
            title: '1分骑会员',
            subTitle: '骑行单单0.01元',
            logoImg: 'https://m.hellobike.com/09b24a472f.png',
          },
        },
        ebike: {
          rideCard: {
            title: '助力车卡',
            tabKey: 'rideCard',
          },
          vip: {
            tabKey: 'vip',
            title: '助力车超级会员',
            subTitle: '30天6次卡+超值权益',
            logoImg: 'https://m.hellobike.com/09b24a472f.png',
          },
          oneCentVip: {
            tabKey: 'oneCentVip',
            title: '1分骑会员',
            subTitle: '骑行单单0.01元',
            logoImg: 'https://m.hellobike.com/09b24a472f.png',
          },
        },
      };
    },
  },


};
</script>
<style lang="less" scoped>
.new-member-container {
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-size: contain;
  overflow-x: hidden;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
    color: transparent;
  }

  .header {
    .header-menu {
      background-size: 100% 100%;
      width: 0.83rem;
      height: 0.24rem;
      margin-top: 0.03rem;
      margin-left: 0.02rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/x4P3I_Slice%206.png?x-oss-process=image/format,webp);
    }
  }

  .categery-tab {
    margin-top: 0.08rem;
  }

  .category-tab-no-app {
    position: absolute;
    top: 0.18rem;
    left: 0.87rem;
  }

  .tarsfer-tab {
    display: flex;
    justify-content: space-between;
    height: 0.48rem;
    width: 100%;
    position: relative;
    padding-top: 0.44rem;

    .tab-left {
      padding-left: 0.3rem;
      width: 48%;
      height: 0.48rem;
      background: linear-gradient(180deg, #fff 0%, #f0f4f7 100%);
      text-align: center;
      line-height: 0.48rem;
      font-size: 0.16rem;
      font-weight: 600;
      border-radius: 0.16rem 0 0 0;
    }

    .tab-left-no-choose {
      width: 66%;
      height: 0.42rem;
      background: #fcefcb;
      text-align: center;
      line-height: 0.48rem;
      font-size: 0.15rem;
      font-weight: 400;
      border-radius: 0.16rem 0 0 0;
      padding-right: 0.12rem;
      margin-top: 0.06rem;
    }

    .tab-middle {
      width: 0.48rem;
      height: 0.49rem;
      background-image: url(https://m.hellobike.com/resource/gallery/61/dCiWRvWg_11.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      position: absolute;
      right: 43%;
    }

    .tab-middle-right {
      background-image: url(https://m.hellobike.com/resource/gallery/61/BgQIUeZy_22.png?x-oss-process=image/quality,q_80);
    }

    .tab-right {
      border-radius: 0 0.16rem 0 0;
      width: 59%;
      height: 0.42rem;
      background: #1b479b;
      padding-top: 0.05rem;
      padding-left: 0.4rem;
      margin-top: 0.06rem;

      .tab-right-one {
        display: flex;
        justify-content: center;

        .tab-right-one-title {
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-size: 0.14rem;
          font-weight: 500;
          line-height: 0.196rem;
          color: #fff2c3;
        }

        .font18 {
          font-size: 0.16rem;
          line-height: 0.32rem;
        }

        .more-cheap {
          border-radius: 0.16rem 0.16rem 0.16rem 0;
          background: #f72626;
          text-align: center;
          color: #fff;
          font-size: 0.1rem;
          padding: 0 0.0296rem;
          line-height: 0.14rem;
          height: 0.14rem;
        }
      }

      .tab-right-two {
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.1rem;
        font-weight: 400;
        line-height: 0.14rem;
        text-align: center;
        color: #8ab4d9;
      }
    }

    .tab-right-choose {
      z-index: 2;
      border-radius: 0 0.16rem 0 0;
      width: 52.5%;
      height: 0.48rem;
      background: linear-gradient(180deg, #fff 0%, #f0f4f7 100%);
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.16rem;
      font-weight: 500;
      line-height: 0.5rem;

      .tab-right-two-title {
        display: flex;
        justify-content: center;

        img.tab-right-logo {
          margin-top: 0.1rem;
          width: 0.32rem;
          height: 0.14rem;
        }
      }
    }

    .tab-right-ebike {
      background: #0269b2;
    }
  }

  .ridetab {
    margin-top: 0.43rem;
    padding-top: 0.01rem;
  }

  .ridetab-ali {
    padding-top: 0.01rem;
  }

  .new-ride-card {
    padding-top: 0.02rem;
    min-height: 100vh;
    background: #f0f4f7;

    &.radius-background {
      box-shadow: 0 -0.01rem 0 0 #fff;
      border-radius: 0.12rem;
      background: linear-gradient(180deg, #d3e8ff 0%, #fff 0.13rem, #f9f9f9 0.337rem);
    }
  }

  .new-member {
    // padding-top: 0.4rem;
    min-height: 100vh;
    border-radius: 0.16rem 0 0 0;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }
  }

  &.free-rights-version {
    .header-menu {
      height: 0.18rem;
      width: 0.6rem;
      margin: 0 0.036rem 0 auto;
    }

    .new-member {
      background: linear-gradient(181.29deg, #f9f0ec 10%, #f0f3f5 14.91%);
    }
  }

  &.new-h5-version {
    // 0.42rem是会员tab的高度
    .new-member {
      background: linear-gradient(180deg, transparent 0.42rem, #fff 0.337rem, #f0f3f5 1.34rem);
    }
  }
}

.no-padding-container {
  padding-top: 0;
}

.isnoapp {
  padding-top: 0.05rem;
}
</style>
